export default "__VITE_ASSET___S4V_LiY__"